var Component = require("!../../../../../../../shared/frontend/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../shared/frontend/node_modules/vue-loader/lib/selector?type=script&index=0!./IncomingCalls.vue"),
  /* template */
  require("!!../../../../../../../shared/frontend/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-777e41eb\"}!../../../../../../../shared/frontend/node_modules/vue-loader/lib/selector?type=template&index=0!./IncomingCalls.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/home/alarmplan/staging/releases/136/frontend/src/views/Admin/PBX/IncomingCalls.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] IncomingCalls.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-777e41eb", Component.options)
  } else {
    hotAPI.reload("data-v-777e41eb", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/Admin/PBX/IncomingCalls.vue
// module id = 947
// module chunks = 1